import styled, { keyframes } from 'styled-components';
import Ico20 from '../Ico20';

const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Wrapper = styled.div`
  background-color: #f4f7f9;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

export const OuterWrapper = styled.div`
  box-sizing: border-box;
  margin: 0 auto;
  width: 36px;
  height: 36px;
  background-color: transparent;
  position: relative;
`;

export const Loader = styled.div`
  box-sizing: border-box;
  top: 0;
  left: 0;
  border-top: 2px solid rgba(38, 50, 56, 0.1);
  border-right: 2px solid rgba(38, 50, 56, 0.1);
  border-bottom: 2px solid rgba(38, 50, 56, 0.1);
  border-left: 2px solid #b0bec5;
  transform: translateZ(0);
  animation: ${rotate360} 1.1s infinite linear;
  border-radius: 50%;
  width: 100%;
  height: 100%;
`;

export const Icon = styled(Ico20)`
  box-sizing: border-box;
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -10px;
  margin-top: -10px;
  color: #90a4ae;
`;

export const Children = styled.div`
  margin: 12px auto 0;
  text-align: center;
  max-width: 288px;
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  color: #90a4ae;
`;
